import React from 'react';
import styled from 'styled-components'

const ImageContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`;

const ImageStyled = styled.img`
    display: inherit;
    object-fit: cover;
    width: 100%;

    @media only screen and (min-width: 768px) {
        height: 100%;
    }

    @media only screen and (min-width: 1200px) {
        width: 600px;
        height: 422px;
    }

    @media only screen and (min-width: 1800px) {
        width: 800px;
    }
`;


const Image = ({ image }) => {
    return (
        <ImageContainer>
            <ImageStyled src={image} alt="" />
        </ImageContainer>
    )
}

export default Image;